import React from 'react';
import '../less/energy-credit.less';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import FilesForDownloadNew from "../../../../../auxiliary-components/shared/FilesForDownloadNew";
import { Preloader } from 'MWComponents';
import hero_data from '../enums/hero_data.json';
import BusinessOrder from '../../../../BusinessOrder';

export default function template() {
    const page = 'energy-credit';

    const handlersMap = {
      toggleHeroModal: () => this.toggleModal()
    };

    const heroData = {
      ...hero_data,
      link: {
        ...hero_data.link,
        onClick: handlersMap[hero_data.link.onClick],
      },
    };

    return (
        <div className="module-energy-credit">
          <Hero
            data={heroData}
            img={hero_img}
          />
          <div className="content">
            <div className="general-info">
              <div className="container">
                <div className="general-info__text">
                  <p>{this.l10n('ENERGY_CREDIT_NEW_GENERAL_INFO_TEXT_01')}</p>
                  <p>{this.l10n('ENERGY_CREDIT_NEW_GENERAL_INFO_TEXT_02')}</p>
                </div>
                <div className="general-info__subtitle">{this.l10n('ENERGY_CREDIT_NEW_GENERAL_INFO_SUBTITLE')}</div>
                <ul className="general-info__list">
                  <li>{this.l10n('ENERGY_CREDIT_NEW_GENERAL_INFO_LIST_01')}</li>
                  <li>{this.l10n('ENERGY_CREDIT_NEW_GENERAL_INFO_LIST_02')}</li>
                  <li>{this.l10n('ENERGY_CREDIT_NEW_GENERAL_INFO_LIST_03')}</li>
                  <li>{this.l10n('ENERGY_CREDIT_NEW_GENERAL_INFO_LIST_04')}</li>
                  <li>{this.l10n('ENERGY_CREDIT_NEW_GENERAL_INFO_LIST_05')}</li>
                  <li>{this.l10n('ENERGY_CREDIT_NEW_GENERAL_INFO_LIST_06')}</li>
                </ul>
              </div>
            </div>
            <FilesForDownloadNew
              widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
              loader={this.state.loader}
            />
          </div>
          {this.state.showModal && <BusinessOrder attribute="energy_credit" closeModal={() => this.toggleModal()} />}
        </div>
    );
}
